export default __webpack_public_path__ + "static/media/SB1.12b137cc.jpg";